import React, { useState, useEffect } from 'react';
import { Button, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import 'antd/dist/reset.css';
import PackagesTable from './PackagesTable';
import styles from './AdminPanel.module.css';

const AdminPanel = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const addingInstanceRoute = '/admin/add-package';
  const asset = '/api/admin/data';
  const comeBackSoon = '/api/admin/logout';
  const cameBack = '/admin-page';

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(asset, {
          method: 'GET',
          credentials: 'include',
        });
        if (response.ok) {
          const result = await response.json();
          setData(result);
        } else {
          if (response.status === 401) {
            message.error('Unauthorized. Redirecting to login.');
            navigate(cameBack, { replace: true });
          } else {
            message.error('Failed to fetch data.');
          }
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        message.error('Server error. Redirecting to login.');
        navigate(cameBack, { replace: true });
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [asset, navigate, cameBack]);

  const handleLogout = async () => {
    try {
      const response = await fetch(comeBackSoon, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      });
      if (response.ok) {
        navigate(cameBack, { replace: true });
      } else {
        message.error('Logout failed.');
      }
    } catch (error) {
      console.error('Logout error:', error);
      message.error('Server error during logout.');
    }
  };

  const handleNavigationToADD = () => {
    navigate(addingInstanceRoute);
  };

  return (
    <div className={styles.adminPanelContainer}>
      <div className={styles.logOutButtonContainer}>
        <Button type="primary" onClick={handleLogout}>
          Log out
        </Button>
      </div>
      <div className={styles.flexButtonsContainer}>
        <button className={styles.flexButton} onClick={handleNavigationToADD}>
          ADD PACKAGE
        </button>
      </div>
      <div className={styles.table}>
        <PackagesTable data={data} loading={loading} />
      </div>
    </div>
  );
};

export default AdminPanel;